<template>
    <div class="db-col-select" style="width: 100%;height: 100%;">
        <el-table ref="the-table" :data="colMetaList" border style="width: 100%;" :height="tableHeight" stripe border :row-key="'columnName'" :row-class-name="getTableRowClassName" @row-dblclick="handleDblClickRow">
            <el-table-column width="40" label="选择" fixed :selectable="isRowSelectable" type="selection"></el-table-column>
            <el-table-column width="60" label="序号" align="right">
                <template slot-scope="rows">
                    <span>{{ rows.row.ordinal }}</span>
                </template>
            </el-table-column>
            <el-table-column width="200" label="列名称" align="left">
                <template slot-scope="rows">
                    <span v-if="rows.row.columnPk" style="font-weight: bold; color : navy;" title="主键">{{ rows.row.columnName }}</span>
                    <span v-else>{{ rows.row.columnName }}</span>
                </template>
            </el-table-column>
            <el-table-column width="200" prop="comment" label="列备注" align="left"></el-table-column>
            <el-table-column width="100" prop="sqlType" label="sql类型" align="left"></el-table-column>
            <el-table-column width="160" prop="javaType" label="java类型" align="left"></el-table-column>
            <el-table-column width="80" prop="charMaxLength" label="字符宽度" align="right"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    // last modified by koqiui
    import {Utils, Jqext} from '../../app.base'
    import {Vue, MsgBox} from '../../app.vues'

    let Toast = Jqext.Toast;

    //数据库表列元数据提供者(tableName, callback({type, data}))
    let __dbColMetaProvider = null;

    //
    export function setDbColMetaProvider(dbColMetaProvider) {
        if (typeof dbColMetaProvider == 'function') {
            __dbColMetaProvider = dbColMetaProvider;
        } else {
            console.error('dbColMetaProvider 应该是个函数(tableName, callback({type, data}))');
        }
    }

    export default {
        name: 'swb-db-col-select',
        desc: '数据库表列选择',

        props: {
            tableHeight: {
                default: '100%'
            },
            //表名
            tableName: {
                type: String
            },
            //初始选择的colName
            iniSelected: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            //初始选择的是否显示
            iniSelectedVisible: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                //表列元数据
                colMetaList: []
            };
        },
        watch: {
            tableName(newVal, oldVal) {
                this.init(true);
            },
            iniSelected(newVal, oldVal) {
                this.init();
            }
        },
        created() {
        },
        mounted() {
            this.theElTable = this.$refs['the-table'];
            //
            this.init(true);
        },
        beforeDestroy() {
            this.theElTable = null;
            this.colMetaList = null;
        },
        methods: {
            //colListHandler 回调( [dbColList])
            fetchCols(colListHandler) {
                let self = this;
                __dbColMetaProvider(this.tableName, function (result) {
                    if (result.success) {
                        colListHandler.call(self, result.data || [], true);
                    } else {
                        Toast.show(result.message, '5000', 'error');
                    }
                });
            },
            initCols(dbColList, forNewList) {
                let colMetaList = dbColList;
                let self = this;
                let validColList = [];
                if (forNewList) {
                    colMetaList.forEach(function (colMeta) {
                        if (colMeta.sqlType == 'TINYINT' && colMeta.javaType == 'java.lang.Integer') {
                            colMeta.javaType = 'java.lang.Boolean';
                        }
                        if (colMeta.columnPk) {
                            colMeta.comment = '<主键>';
                        }
                        //
                        colMeta.unselectable = !self.isRowSelectable(colMeta);
                        if (!colMeta.unselectable || self.iniSelectedVisible) {
                            validColList.push(colMeta)
                        }
                    });
                } else {
                    colMetaList.forEach(function (colMeta) {
                        colMeta.unselectable = !self.isRowSelectable(colMeta);
                        if (!colMeta.unselectable || self.iniSelectedVisible) {
                            validColList.push(colMeta)
                        }
                    });
                }
                this.colMetaList = validColList;
                //
                this.$nextTick(function () {
                    this.theElTable.doLayout();
                })
            },
            init(refetchCols) {
                if (__dbColMetaProvider == null) {
                    let errMsg = 'dbColMetaProvider 尚未设置';
                    console.error(errMsg);
                    Toast.show(errMsg, 5000, 'error');
                    return;
                }
                //
                if (refetchCols) {
                    this.fetchCols(this.initCols);
                } else {
                    this.initCols(this.colMetaList, false);
                }
            },
            //
            isRowSelectable(row, rowIndex) {
                let iniSelected = this.iniSelected || [];
                let colName = row.columnName;
                return iniSelected.indexOf(colName) == -1;
            },
            isRowSelected(row) {
                let selectedRows = this.theElTable.selection || [];
                return selectedRows.indexOf(row) != -1;
            },
            getTableRowClassName({row, rowIndex}) {
                let classNames = '';
                if (this.isRowSelected(row)) {
                    classNames += 'selected';
                }
                if (!this.isRowSelectable(row)) {
                    classNames += ' unselectable';
                }
                return classNames;
            },
            handleDblClickRow(row) {
                if (this.isRowSelectable(row)) {
                    this.theElTable.toggleRowSelection(row);
                }
            },
            getSelected() {
                let retCols = [];
                let selectedRows = this.theElTable.selection || [];
                selectedRows.forEach(function (colMeta) {
                    let retMeta = Utils.merge(colMeta);
                    retCols.push(retMeta);
                });
                //
                return retCols;
            }
        }
    }

</script>

<style>
    .db-col-select > .el-table .el-table__body tr.selected > td {
        background-color: #FFEFE5 !important;
        color: #333333;
    }

    .db-col-select > .el-table .el-table__body tr.unselectable > td {
        font-style: italic;
        color: #AAAAAA;
    }
</style>



// WEBPACK FOOTER //
// src/compo/query/DbColSelect.vue